export const mic = () => (
  <path
    d="M19 10v2a7 7 0 01-7 7m0 0a7 7 0 01-7-7v-2m7 9v4m-4 0h8M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
